import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/ekgImport.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../../options/services/options.service'

export function* setEkgFilterFromTimeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getEkgFilterFromTimeOptions])
    const { entity } = response
    yield put(actions.setFromTimeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setEkgFilterFromTimeOptions() error: ${e}`))
  }
}
export function* setEkgFilterFromTimeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setEkgFilterFromTimeOptions)
}
